export default __webpack_public_path__ + "static/dark-bg-9351f639863eccdf7416f76adfee0184.png";